import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { defaultButtonClasses, secondaryButtonClasses } from "@/constants/ui";
import { ClockPlus, Lock } from "lucide-react";
import type { BookingType } from "../types";

interface BookingTypeToggleProps {
  value: BookingType;
  onChange: (type: BookingType) => void;
  disabled?: boolean;
}

export const BookingTypeToggle = ({ value, onChange, disabled = false }: BookingTypeToggleProps) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label className="text-sm font-medium">What type of booking?</Label>
      <div className="flex gap-2 w-full">
        <Button
          type="button"
          variant={value === "adhoc" ? "default" : "outline"}
          className={`flex-1 ${value === "adhoc" ? defaultButtonClasses : secondaryButtonClasses}`}
          onClick={() => onChange("adhoc")}
          disabled={disabled}
        >
          <ClockPlus /> Flexible
        </Button>
        <Button
          type="button"
          variant={value === "slot" ? "default" : "outline"}
          className={`flex-1 ${value === "slot" ? defaultButtonClasses : secondaryButtonClasses}`}
          onClick={() => onChange("slot")}
          disabled={disabled}
        >
          <Lock /> Slot
        </Button>
      </div>
    </div>
  );
};

export default BookingTypeToggle;
